import { MapContainer, TileLayer, GeoJSON, Tooltip } from 'react-leaflet';
import alaskaDistricts from '../data/alaska_districts.json'; // District GeoJSON
import alaskaPrecincts1 from '../data/alaska_precincts_1.json'; // Precinct GeoJSON
import alaskaPrecincts2 from '../data/alaska_precincts_2.json'; // Precinct GeoJSON
import '../styles/map.css';
import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import { Form } from "react-bootstrap";

// src/polyfills.js
if (!document.namespaces) {
  document.namespaces = {
    add: () => ({}) // Minimal mock implementation
  };
}
async function fetchCandidateData() {
  try {
    const candidateName = "Coulombe, Julie"; // Replace with the actual candidate name you want to fetch data for
    const response = await fetch(`https://oa5bxako8d.execute-api.us-east-1.amazonaws.com/prod/votes-by-district-party?name=${encodeURIComponent(candidateName)}`);    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json(); // Parse JSON body into JS object
    console.log("Parsed data:", data);

    // Optional: turn it into a dictionary if it's an array
    if (Array.isArray(data)) {
      const dictionary = {};
      for (const item of data) {
        // You can choose the key and value structure
        dictionary[item.id] = item; // or item.name, or whatever makes sense
      }
      return dictionary;
    }

    return data; // Already a dictionary
  } catch (err) {
    console.error("Fetch failed:", err);
    return {};
  }
}

const Map = () => {
  console.log(fetchCandidateData());

  // Combine the two GeoJSON files into one for precincts
  const [alaskaPrecincts, setAlaskaPrecincts] = useState(null);
  // toggle between showing districts and precincts
  const [showPrecincts, setShowPrecincts] = useState(false);


  useEffect(() => {
    const loadGeoJSON = async () => {
      try {
        const combined = {
          type: "FeatureCollection",
          features: [...alaskaPrecincts1.features, ...alaskaPrecincts2.features],
        };

        setAlaskaPrecincts(combined);
      } catch (err) {
        console.error("Failed to load GeoJSON files", err);
      }
    };

    loadGeoJSON();
  }, []);

  const alaskaBounds = [
    [41.2, -19.2], // Southwest corner
    [61.6, -119.9], // Northeast corner
  ];

  const democratColor = "rgba(14, 65, 118, 1)"; // Blue
  const neutralColor = "rgba(255, 255, 255, 1)"; // White
  const republicanColor = "rgba(154, 18, 42, 1)"; // Red


  const getDisctrictColor = (voteRatio) => {
    if (voteRatio === 0.5) {
      return neutralColor; // White
    }
    
    let t = 0;
    let neutralColorArray = neutralColor.slice(5, -1).split(",");
    // Blue to white
    if (voteRatio < 0.5) {
      t = voteRatio * 2; // Scale to 0 - 1
      var colorArray = democratColor.slice(5, -1).split(",");
    } 
    // White to red
    else if (voteRatio > 0.5) {
      t = (voteRatio - 0.5) * 2;
      var colorArray = republicanColor.slice(5, -1).split(",");
    }

    const r = Math.round(parseInt(neutralColorArray[0]) + (parseInt(colorArray[0]) - parseInt(neutralColorArray[0])) * t);  // Interpolate red
    const g = Math.round(parseInt(neutralColorArray[1]) + (parseInt(colorArray[1]) - parseInt(neutralColorArray[1])) * t);  // Interpolate green
    const b = Math.round(parseInt(neutralColorArray[2]) + (parseInt(colorArray[2]) - parseInt(neutralColorArray[2])) * t);  // Interpolate blue

    return `rgb(${r}, ${g}, ${b})`;
  }

  const onEachDistrict = (feature, layer) => {
    layer.on({
      click: (e) => {
        const layer = e.target;

        if (feature.properties.GEOID) {
          const { NAMELSAD, GEOID } = layer.feature.properties; // Access properties directly from the layer
          const content = `<strong>${NAMELSAD}</strong><br/>GEOID: ${GEOID}`; // change content string to query db for more info
          layer.bindPopup(content).openPopup();
        }
        else if (feature.properties.district) {
          const { precinct } = layer.feature.properties["Precinct_N"]; // Access properties directly from the layer
          const content = `<strong>${precinct}</strong><br/>Precinct: ${precinct}`; // change content string to query db for more info
          layer.bindPopup(content).openPopup();
        }
      },
       mouseover: (e) => {
         e.target.setStyle({ weight: 3, color: '#666', fillOpacity: 0.5 });
       },
       mouseout: (e) => {
         e.target.setStyle({ weight: 1, color: '#3388ff', fillOpacity: 1 });
       },
    });
  };

  const style = (feature) => {
    let fillColor = getDisctrictColor(Math.random()); // Replace with actual vote ratio
    return {
      fillColor: fillColor,
      weight: 1,
      opacity: 1,
      color: 'white',
      dashArray: '3',
      fillOpacity: 1,
    };
  }
  
  return (
    <div className="map-container">
      <MapContainer 
        center={[64.2008, -149.4937]} 
        zoom={4} 
        style={{ height: '900px', width: '100%' }}
        bounds={alaskaBounds}
        maxBoundsViscosity={1.0}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        />
        {showPrecincts && alaskaPrecincts && (
          <GeoJSON 
            data={alaskaPrecincts} 
            onEachFeature={onEachDistrict} 
            style={style}
          />
        )}

        {!showPrecincts && (
          <GeoJSON 
            data={alaskaDistricts} 
            onEachFeature={onEachDistrict} 
            style={style}
          />
        )}
      </MapContainer>
      <Form className="mb-3" style={{ padding: '1rem' }}>
        <Form.Check 
          type="switch"
          id="custom-switch"
          label="Toggle Districts/Precincts View"
          checked={showPrecincts}
          onChange={(e) => setShowPrecincts(e.target.checked)}
          className="fs-4"
        />
      </Form>
    </div>
  );
};

export default Map;
